const overflowBackgroundColor = 'rgba(52, 64, 76, .6)';

export { overflowBackgroundColor };
